import React from "react";
import "./TourCard.css";
import Card from "./Card";
import Button from "../../../../Button"

function index() {
  return (
    <div className="tourcard">
      <h1>Popular Tours</h1>
      <p>Where TourUzbekistan Plus members are staying and saving</p>
      <div className="cards">
        <Card
          src="https://davidsbeenhere.com/wp-content/uploads/2019/12/15-things-you-must-see-and-do-in-tashkent-uzbekistan-central-asia-davidsbeenhere12.jpg"
          title="asdasdas"
          text="200"
          btntext="asdas"
          rating="1222"
        />
        <Card
          src="https://davidsbeenhere.com/wp-content/uploads/2019/12/15-things-you-must-see-and-do-in-tashkent-uzbekistan-central-asia-davidsbeenhere12.jpg"
          title="asdasdas"
          text="200"
          btntext="asdas"
          rating="1222"
        />
        <Card
          src="https://davidsbeenhere.com/wp-content/uploads/2019/12/15-things-you-must-see-and-do-in-tashkent-uzbekistan-central-asia-davidsbeenhere12.jpg"
          title="asdasdas"
          text="200"
          btntext="asdas"
          rating="1222"
        />
        <Card
          src="https://davidsbeenhere.com/wp-content/uploads/2019/12/15-things-you-must-see-and-do-in-tashkent-uzbekistan-central-asia-davidsbeenhere12.jpg"
          title="asdasdas"
          text="200"
          btntext="asdas"
          rating="1222"
        />
        
      </div>
      <div className="cards_bottom">

    <Button title="all tours"/>
      </div>
    </div>
  );
}

export default index;
